module.exports = {
  "zones": {
    "Asia/Macao": ["z", {
      "wallclock": -765331200000,
      "format": "C%sT",
      "abbrev": "CST",
      "offset": 28800000,
      "posix": -765363600000,
      "save": 0,
      "rules": "Macau"
    }, {
      "wallclock": -884480400000,
      "format": "+09/+10",
      "abbrev": "+09",
      "offset": 32400000,
      "posix": -884509200000,
      "save": 0,
      "rules": "Macau"
    }, {
      "wallclock": -2056665600000,
      "format": "CST",
      "abbrev": "CST",
      "offset": 28800000,
      "posix": -2056692850000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 27250000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "Macau": [{
      "from": 1979,
      "to": 1979,
      "month": 4,
      "day": [7, 13],
      "time": 210,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1979,
      "to": 1979,
      "month": 9,
      "day": [0, 16],
      "time": 210,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1967,
      "to": 1976,
      "month": 9,
      "day": [0, 16],
      "time": 210,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1975,
      "to": 1976,
      "month": 3,
      "day": [0, 16],
      "time": 210,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1965,
      "to": 1973,
      "month": 3,
      "day": [0, 16],
      "time": 210,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1973,
      "to": 1973,
      "month": 11,
      "day": [7, 30],
      "time": 210,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1965,
      "to": 1966,
      "month": 9,
      "day": [0, 16],
      "time": 150,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1956,
      "to": 1964,
      "month": 10,
      "day": [0, 1],
      "time": 210,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1957,
      "to": 1964,
      "month": 2,
      "day": [0, 18],
      "time": 210,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1954,
      "to": 1956,
      "month": 2,
      "day": [6, 17],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1955,
      "to": 1955,
      "month": 10,
      "day": [7, 5],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1953,
      "to": 1954,
      "month": 9,
      "day": [6, -31],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1952,
      "to": 1953,
      "month": 3,
      "day": [6, 1],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1952,
      "to": 1952,
      "month": 10,
      "day": [7, 1],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1951,
      "to": 1951,
      "month": 2,
      "day": [7, 31],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1951,
      "to": 1951,
      "month": 9,
      "day": [7, 28],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1949,
      "to": 1950,
      "month": 3,
      "day": [6, 1],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1949,
      "to": 1950,
      "month": 9,
      "day": [6, -31],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1948,
      "to": 1948,
      "month": 4,
      "day": [7, 2],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1948,
      "to": 1948,
      "month": 9,
      "day": [7, 31],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1947,
      "to": 1947,
      "month": 3,
      "day": [7, 19],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1947,
      "to": 1947,
      "month": 10,
      "day": [7, 30],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1946,
      "to": 1946,
      "month": 3,
      "day": [7, 30],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1946,
      "month": 8,
      "day": [7, 30],
      "time": 1440,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1943,
      "month": 3,
      "day": [7, 30],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "",
      "saved": 0
    }, {
      "from": 1943,
      "to": 1943,
      "month": 8,
      "day": [7, 30],
      "time": 1380,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 10,
      "day": [7, 17],
      "time": 1380,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};